import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './App.css';
import qrCodeImage from './qr_code.jpg'; // เพิ่มไฟล์ QR Code ของคุณในโฟลเดอร์ src

function Footer() {
  return (
    <footer className="footer-section py-4">
      <Container>
        <Row>
          <Col md={4} className="text-center">
            <h5>เวลาทำการ</h5>
            <p>วันจันทร์ พุธ ศุกร์: 17.00 - 20.00 น.</p>
            <p>เสาร์ - อาทิตย์: 09.00 - 14.00 น.</p>
          </Col>
          <Col md={4} className="text-center">
            <h5>เบอร์ติดต่อ</h5>
            <p>โทร: 080-882-8848</p>
            <p>Line: @tnp.heartclinic</p>
            <p>Facebook: facebook.com/Thanaphruetclinic/</p>
          </Col>
          <Col md={4} className="text-center">
            <h5>Line Chat</h5>
            <img
              src={qrCodeImage}
              alt="QR Code"
              className="qr-code-img"
            />
          </Col>
        </Row>
        <Col md={4} className="text-center" >
        <br /><br />
            <p>website coding by Thanapat Issarawattana lambforever123@gmail.com</p>
          </Col>
      </Container>
    </footer>
  );
}

export default Footer;